<template>
  <div class="dashboard-container">
    <!-- 学员详情 -->
    <div class="body">
      <span class="detail">学员详情</span>
      <span
        class="el-icon-circle-close"
        style="font-size: 28px"
        @click="goBack"
      ></span>
    </div>
    <div class="app-container">
      <div class="filter-container">
        <div class="headers">
          <el-button type="text" icon="el-icon-edit" @click="cancelStudent"
            >修改信息</el-button
          >
        </div>
        <div class="dd">
          <span class="realname">{{ studentData.realname }}</span>
        </div>
        <div style="background-color: white">
          <el-form :inline="true">
            <el-row>
              <el-col class="bbb" style="width: 100% !important; display: flex">
                <!-- <el-form-item
                  label="姓名:"
                  style="float: left; margin-left: 10px"
                >
                  <span>{{ studentData.realname }}</span>
                </el-form-item> -->
                <div class="mes" style="width: 60%">
                  <el-form-item label="性别:">
                    <span class="sex">{{
                      studentData.sex === 1 ? "男" : "女"
                    }}</span>
                  </el-form-item>
                  <el-form-item label="年级:">
                    <span>{{ studentData.gradeStr }}</span>
                  </el-form-item>
                  <el-form-item label="联系电话:">
                    <span>{{ studentData.telephone }}</span>
                  </el-form-item>
                  <el-form-item label="家庭住址:">
                    <span>{{ studentData.address }}</span>
                  </el-form-item>

                  <!-- <el-form-item label="课消详情:">
                    <span>{{ studentData.address }}</span>
                  </el-form-item> -->

                  <!-- <el-form-item label="跟进老师:">
                    <span
                      v-for="(item, index) in studentData.progressTeacherName"
                      :key="index"
                      >{{ item }}/
                      </span
                    >
                  </el-form-item> -->
                  <!-- <template>
                    <el-form-item label="跟进老师:">
                      <span
                        v-for="(item, index) in studentData.progressTeacherName"
                        :key="index"
                      >
                        {{ item}}{{index !== studentData.progressTeacherName.length - 1
                            ? "/"
                            : ""
                        }}
                      </span>
                    </el-form-item>
                  </template> -->
                  <div style="display: flex; margin-left: 20px">
                    <el-form-item label="课消详情:">
                      <span>{{ studentData.planName }}</span>
                    </el-form-item>
                  </div>
                </div>

                <div
                  style="
                    margin-bottom: 20px;
                    text-align: start;
                    width: 60%;
                    margin-top: 30px;
                  "
                >
                  <div
                    style="
                      margin-top: 10px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                  >
                    学业课总课时:{{ findStudentHour.schoolSumHour }}
                  </div>
                  <div
                    style="
                      margin-top: 10px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                  >
                    学业课消耗课时:{{ findStudentHour.schoolConsumeHour }}
                  </div>
                  <div
                    style="
                      margin-top: 10px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                  >
                    学业课剩余课时:{{ findStudentHour.schoolResidueHour }}
                  </div>
                  <div
                    style="
                      margin-top: 10px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                  >
                    家庭教育总课时:{{ findStudentHour.familySumHour }}
                  </div>
                  <div
                    style="
                      margin-top: 10px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                  >
                    家庭教育消耗课时:{{ findStudentHour.familyConsumeHour }}
                  </div>
                  <div
                    style="
                      margin-top: 10px;
                      margin-right: 10px;
                      margin-left: 10px;
                    "
                  >
                    家庭教育剩余课时:{{ findStudentHour.familyResidueHour }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <div class="sign">
        <div class="suun">
          <el-form :inline="true">
            <el-form-item
              label="签约产品"
              style="float: left; margin-left: 10px; margin-top: 10px"
            >
            </el-form-item>
            <el-form-item style="margin-top: 10px; margin-right: 65px">
              <el-button
                size="mini"
                type="primary"
                class="btns"
                icon="el-icon-plus"
                @click="newSigning(id)"
                >新加签约</el-button
              >
              <el-button
                size="mini"
                type="primary"
                class="btns"
                icon="el-icon-edit"
                @click="editSigning()"
                >修改签约</el-button
              >
              <el-button
                size="mini"
                type="primary"
                class="btns"
                icon="el-icon-close"
                @click="deleteSigning"
                >删除签约</el-button
              >
              <el-button
                size="mini"
                type="primary"
                class="btns"
                icon="el-icon-plus"
                @click="addigning()"
                >添加/修改课消方案</el-button
              >

              <!-- <el-button
                size="mini"
                type="primary"
                class="btns"
                icon="el-icon-edit"
                @click="addigning1()"
                >修改课消方案</el-button
              > -->
            </el-form-item>
          </el-form>
        </div>
        <el-divider class="line"></el-divider>
        <!-- 产品列表 -->
        <div class="table">
          <el-table
            :header-cell-style="{
              background: '#fafafa',
            }"
            border
            ref="multipleTable"
            :data="productData"
            tooltip-effect="dark"
            style="width: 100%; margin-top: -8px"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <!-- <el-table-column prop="classType" label="添加日期">
            </el-table-column> -->
            <el-table-column
              prop="categoryName"
              label="课程"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="classType"
              label="班型"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.classType === 1">1v1</span>
                <span v-if="scope.row.classType === 2">1v2</span>
                <span v-if="scope.row.classType === 3">1v3</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="lessonNum"
              label="课节次数"
            ></el-table-column>
            <el-table-column prop="lessonPrice" label="课时单价">
            </el-table-column>
            <el-table-column prop="teacherName" label="跟进老师">
            </el-table-column>
            <el-table-column prop="educationTypeNames" label="上课方式">
            </el-table-column>
            <el-table-column prop="lossStatus" label="是否流失">
              <template slot-scope="scope">
                <span v-if="scope.row.lossStatus === 0">未知</span>
                <span v-if="scope.row.lossStatus === 1">流失</span>
                <span v-if="scope.row.lossStatus === 2">未流失</span>
              </template>
            </el-table-column>
            <el-table-column prop="lossReasson" label="流失原因">
            </el-table-column>
            <el-table-column prop="lossTime" label="流失时间">
            </el-table-column>
            <!-- <el-table-column prop="contractName" label="方案名称">
            </el-table-column> -->
            <!-- <el-table-column prop="startTime" label="开始日期">
            </el-table-column>
            <el-table-column prop="endTime" label="有效期至"> </el-table-column> -->
          </el-table>
        </div>
      </div>

      <div class="ft">
        <div class="footer">
          <div class="card">
            <el-tabs
              v-model="activeName"
              type="card"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                style="float: right; margin-right: 50px; margin-bottom: 15px"
                label="课表排课"
                name="classPlan"
              >
                <!-- <el-button type="primary" style="margin-right: 50px;" @click="addClassPlan">课表排课</el-button>
                <el-button type="danger" style="margin-right: -40px;" @click="batchDel">批量删除</el-button> -->
              </el-tab-pane>
              <el-tab-pane
                style="float: left; margin-left: 10px; margin-bottom: 15px"
                label="课程明细"
                name="first"
              ></el-tab-pane>
              <el-tab-pane
                style="float: left; margin-left: 10px; margin-bottom: 15px"
                label="课程统计"
                name="second"
                >课程统计</el-tab-pane
              >
              <el-tab-pane
                style="float: left; margin-left: 10px; margin-bottom: 15px"
                label="学生成绩"
                name="result"
              ></el-tab-pane>
              <el-tab-pane
                style="float: left; margin-left: 10px; margin-bottom: 15px"
                label="电话沟通"
                name="telephoneCommunication"
              ></el-tab-pane>
            </el-tabs>
            <div class="classPlanBox" v-show="activeName === 'classPlan'">
              <el-form label-width="100px" class="search">
                <el-form-item label="课程日期">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="serachObj.createTimes"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="课程名称">
                  <el-select
                    placeholder="请选择"
                    v-model="serachObj.categoryId"
                  >
                    <el-option
                      v-for="item in className"
                      :key="item.id"
                      :label="item.categoryName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上课老师">
                  <el-select placeholder="请选择" v-model="serachObj.teacherId">
                    <el-option
                      v-for="item in classTeacher"
                      :key="item.id"
                      :label="item.realname"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="结课状态">
                  <el-select
                    placeholder="请选择"
                    v-model="serachObj.classEnding"
                  >
                    <el-option
                      v-for="item in educationType"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上课方式">
                  <el-select
                    placeholder="请选择"
                    v-model="serachObj.educationType"
                  >
                    <el-option
                      v-for="item in classEnding"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-search"
                    size="small"
                    @click="handleSearchBtn"
                    >搜索</el-button
                  >
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-close"
                    size="small"
                    @click="handleClearBtn"
                    >清除</el-button
                  >
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-edit-outline"
                    size="small"
                    @click="addClassPlan"
                    >课表排课</el-button
                  >
                  <el-button
                    type="danger"
                    class="btns"
                    icon="el-icon-close"
                    size="small"
                    @click="batchDel"
                    >批量删除</el-button
                  >
                </el-form-item>
              </el-form>
              <el-table
                :data="tableData"
                border
                style="width: 100%"
                @selection-change="changeSelection"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="courseName" label="课程">
                </el-table-column>
                <el-table-column prop="courseDate" label="日期">
                </el-table-column>
                <el-table-column prop="courseTimeOn" label="开始时间">
                </el-table-column>
                <el-table-column prop="courseEndTime" label="结束时间">
                </el-table-column>
                <el-table-column prop="courseTeacherName" label="老师">
                </el-table-column>
                <el-table-column prop="classMode" label="上课方式">
                </el-table-column>
                <el-table-column label="结课状态">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.classEnding === 1 ? "已结课" : "未结课"
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="productClassType"
                  label="班型"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.productClassType === 1
                        ? "1V1"
                        : scope.row.productClassType === 2
                        ? "1v2"
                        : scope.row.productClassType === 3
                        ? "1v3"
                        : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="classPersonType"
                  label="上课人员"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.classPersonType === 1">孩子</span>
                    <span v-if="scope.row.classPersonType === 2"
                      >孩子和父亲</span
                    >
                    <span v-if="scope.row.classPersonType === 3"
                      >孩子和母亲</span
                    >
                    <span v-if="scope.row.classPersonType === 4">父亲</span>
                    <span v-if="scope.row.classPersonType === 5">母亲</span>
                    <span v-if="scope.row.classPersonType === 6"
                      >父亲和母亲</span
                    >
                    <span v-if="scope.row.classPersonType === 7"
                      >孩子、父亲、母亲</span
                    >
                  </template>
                </el-table-column>

                <!-- <el-table-column prop="deductCourseNum" label="实扣课次" show-overflow-tooltip>
                 </el-table-column>
                <el-table-column prop="classMoney" label="课时费">
                </el-table-column> -->
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="editItem(scope.row)"
                      >编辑</el-button
                    >
                    <!-- <el-button type="text" size="small" @click="deleItem(scope.row.scheduleId)">删除</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="paging.pageNum"
                :page-size="paging.pageSize"
                layout="total, prev, pager, next"
                :total="totalAll"
              ></el-pagination>
            </div>
            <div class="course" v-show="activeName === 'first'">
              <el-form label-width="100px" class="search">
                <el-form-item label="课程日期">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="serachObj.createTimes"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="课程名称">
                  <el-select
                    placeholder="请选择"
                    v-model="serachObj.categoryId"
                  >
                    <el-option
                      v-for="item in className"
                      :key="item.id"
                      :label="item.categoryName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上课老师">
                  <el-select placeholder="请选择" v-model="serachObj.teacherId">
                    <el-option
                      v-for="item in classTeacher"
                      :key="item.id"
                      :label="item.realname"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="结课状态">
                  <el-select
                    placeholder="请选择"
                    v-model="serachObj.classEnding"
                  >
                    <el-option
                      v-for="item in educationType"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上课方式">
                  <el-select
                    placeholder="请选择"
                    v-model="serachObj.educationType"
                  >
                    <el-option
                      v-for="item in classEnding"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="searchBtn"
                    class="btns"
                    icon="el-icon-search"
                    size="small"
                    >搜索</el-button
                  >
                  <el-button
                    type="primary"
                    @click="clearBtn"
                    class="btns"
                    icon="el-icon-close"
                    size="small"
                    >清除</el-button
                  >
                </el-form-item>
              </el-form>
              <el-table :key="keys" :data="courseList" border>
                <el-table-column prop="courstDate" label="课程日期">
                </el-table-column>
                <el-table-column prop="courseStartTime" label="开始时间">
                </el-table-column>
                <el-table-column prop="courseEndTime" label="结束时间">
                </el-table-column>
                <el-table-column prop="courseName" label="课程名称">
                </el-table-column>
                <el-table-column prop="courseTeacherName" label="上课老师">
                </el-table-column>
                <el-table-column label="结课状态">
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.classEnding === 1 ? "已结课" : "未结课"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="deductCourseNum"
                  label="实扣课次"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column label="课时费">
                  <template slot-scope="scope">
                    <span
                      v-show="scope.row.flog"
                      class="el-icon-view"
                      @click="clic(scope)"
                    ></span>
                    <span v-show="!scope.row.flog" @click="clic(scope)">{{
                      scope.row.classMoney
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="classMode" label="上课方式">
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page.sync="serachObj.pageNo"
                :page-size="serachObj.pageSize"
                layout="total, prev, pager, next"
              ></el-pagination>
              <p style="margin-top: -23px">{{ serachObj.nums }}</p>
            </div>
            <div class="course" v-show="activeName === 'second'">
              <el-table :data="countList" border>
                <!-- <el-table-column type="index"></el-table-column> -->
                <el-table-column prop="courseName" label="课程名称">
                </el-table-column>
                <el-table-column
                  prop="courseTotalNum"
                  label="购买总课次"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column prop="alreadyTotalNum" label="已上课次">
                </el-table-column>
                <el-table-column type="expand" label="老师上课节数">
                  <template slot-scope="props">
                    <el-table
                      :data="props.row.teacherCourseInfos"
                      label-position="center"
                      inline
                      class="demo-table-expand"
                    >
                      <el-table-column prop="teacherName" label="上课老师">
                      </el-table-column>
                      <el-table-column prop="courseNum" label="课节数">
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column prop="remainTotalNum" label="剩余课次">
                </el-table-column>
                <el-table-column prop="expireTime" label="到期时间">
                </el-table-column>
                <!-- <el-table-column type="expand" label="老师上课节数">
                <template slot-scope="props">
                  <el-table
                    :data="props.row.teacherCourseInfos"
                    label-position="center"
                    inline
                    class="demo-table-expand"
                  >
                    <el-table-column prop="teacherName" label="上课老师">
                    </el-table-column>
                    <el-table-column prop="courseNum" label="课节数">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column> -->
              </el-table>
            </div>

            <div class="classPlanBox" v-show="activeName === 'result'">
              <el-form label-width="100px" class="search">
                <!-- <el-form-item label="考试时间">
                  <el-date-picker
                    v-model="resultList.timers"
                    type="monthrange"
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份">
                  </el-date-picker>
                </el-form-item> -->
                <el-form-item label="考试时间">
                  <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="resultList.timers"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="考试阶段">
                  <el-select
                    placeholder="请选择"
                    v-model="resultList.examStage"
                  >
                    <el-option
                      v-for="item in secondstage"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-search"
                    size="small"
                    @click="handleSearchBtnRearch"
                    >搜索</el-button
                  >
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-close"
                    size="small"
                    @click="handleClearBtnRearch"
                    >清除</el-button
                  >
                </el-form-item>
              </el-form>
              <el-button
                type="primary"
                style="float: right; margin-bottom: 20rpx"
                @click="editSecond('add')"
                >添加</el-button
              >
              <el-table
                :data="secondListData"
                border
                style="width: 100%"
                @selection-change="changeSelection"
              >
                <el-table-column prop="examStage" label="考试阶段">
                  <template slot-scope="scope">
                    <p v-if="scope.row.examStage === 1">诊断成绩</p>
                    <p v-if="scope.row.examStage === 2">开学考</p>
                    <p v-if="scope.row.examStage === 3">月考</p>
                    <p v-if="scope.row.examStage === 4">期中考</p>
                    <p v-if="scope.row.examStage === 5">期末考</p>
                  </template>
                </el-table-column>
                <el-table-column prop="examTime" label="考试时间">
                </el-table-column>
                <el-table-column prop="examScore" label="考试总分">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="editSecond('edit', scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="editSecond('details', scope.row)"
                      >详情</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChanges"
                @current-change="handleCurrentChanges"
                :current-page.sync="resultList.pageNo"
                :page-size="resultList.pageSize"
                layout="total, prev, pager, next"
                :total="resultList.total"
              ></el-pagination>
            </div>

            <div
              class="classPlanBox"
              v-show="activeName === 'telephoneCommunication'"
            >
              <el-form label-width="100px" class="search">
                <el-form-item label="预约时间">
                  <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="input1"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="实际沟通时间">
                  <el-date-picker
                    type="daterange"
                    placeholder="实际沟通"
                    v-model="input2"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="沟通人">
                  <el-select
                    placeholder="请选择"
                    v-model="input3"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in classTeacher"
                      :key="item.id"
                      :label="item.realname"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="完成进度">
                  <el-select placeholder="请选择" v-model="input4">
                    <el-option
                      v-for="item in educationType1"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-plus"
                    size="small"
                    @click="handleAmend('添加')"
                    >添加</el-button
                  >
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-search"
                    size="small"
                    @click="handleSearchBtn1"
                    >搜索</el-button
                  >
                  <el-button
                    type="primary"
                    class="btns"
                    icon="el-icon-close"
                    size="small"
                    @click="handleClearBtn1"
                    >清除</el-button
                  >
                </el-form-item>
              </el-form>
              <el-table
                :data="communicationListData"
                border
                style="width: 100%"
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'center',
                }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column prop="courseName" label="沟通次数">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="appointmentTime" label="预约时间">
                </el-table-column>
                <el-table-column prop="communicationTime" label="实际沟通时间">
                </el-table-column>
                <el-table-column prop="communicationRecord" label="沟通录音">
                  <template slot-scope="scope">
                    <div
                      v-for="(itme, index) in scope.row.communicationRecord"
                      :key="index"
                    >
                      <span style="color: #0d95ef" @click="handleView1(itme)">{{
                        itme.name
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="screenshot" label="沟通截图">
                  <template slot-scope="scope">
                    <div
                      v-for="(itme, index) in scope.row.screenshot"
                      :key="index"
                    >
                      <span style="color: #0d95ef" @click="handleView2(itme)">{{
                        itme.name
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="communicationGoal"
                  label="本次沟通目的"
                ></el-table-column>
                <!-- <el-table-column prop="communicationPersonNames" label="沟通人"> </el-table-column> -->
                <el-table-column prop="completePlan" label="完成进度">
                  <template slot-scope="scope">
                    <span
                      v-if="
                        scope.row.completePlan === '0' ||
                        scope.row.completePlan === 0
                      "
                      >未完成</span
                    >
                    <span
                      v-if="
                        scope.row.completePlan === '1' ||
                        scope.row.completePlan === 1
                      "
                      >进行中</span
                    >
                    <span
                      v-if="
                        scope.row.completePlan === '2' ||
                        scope.row.completePlan === 2
                      "
                      >已完成</span
                    >
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="代办列表" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        (dialogToDoTasks = true), (itmesID = scope.row.id + '')
                      "
                      >详情</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="handleAmend('修改', scope.row)"
                      >修改</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChangess"
                @current-change="handleCurrentChangess"
                :current-page.sync="pageNums"
                :page-size="pageSizes"
                layout="total, prev, pager, next"
                :total="totals"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <!-- 课表排课 -->
      <el-dialog
        :title="shwoTitle ? '添加排课' : '编辑排课'"
        :visible.sync="classPlanDia"
        :width="'55%'"
      >
        <el-form>
          <el-form-item label="课程" label-width="80px">
            <el-select
              class="select"
              clearable
              v-model="ClassPlanObj.courseId"
              placeholder="请选择课程"
              style="width: 100%"
            >
              <el-option
                v-for="source in courses"
                :key="source.id"
                :value="source.id"
                :label="source.categoryName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" label-width="80px">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ClassPlanObj.courseDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开始时间" label-width="80px">
            <mz-time-select
              @clena="clean"
              :timePeriod="'start'"
              @startTimeSelect="startTimeSelect"
              :childPlaceholder="'开始时间'"
              :valueTime="ClassPlanObj.courseTimeOn"
            ></mz-time-select>
          </el-form-item>
          <el-form-item label="结束时间" label-width="80px">
            <mz-time-select
              @clean="clean"
              :timePeriod="'end'"
              :childPlaceholder="'结束时间'"
              @startTimeSelect="startTimeSelect"
              :valueTime="ClassPlanObj.courseEndTime"
            ></mz-time-select>
          </el-form-item>
          <el-form-item label="老师" label-width="80px">
            <el-select
              class="select"
              clearable
              v-model="ClassPlanObj.teacherId"
              placeholder="请选择跟进老师"
              style="width: 100%"
            >
              <el-option
                v-for="source in teacherLists"
                :key="source.id"
                :value="source.id"
                :label="source.realname"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学员" label-width="80px">
            <el-input v-model="studentName" disabled></el-input>
          </el-form-item>
          <el-form-item
            label="上课方式"
            label-width="80px"
            style="text-align: left"
          >
            <el-radio-group v-model="ClassPlanObj.educationType">
              <el-radio :label="1">网课</el-radio>
              <el-radio :label="2">上门</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="shwoTitle"
            label="是否首次课"
            label-width="90px"
            style="text-align: left"
          >
            <el-radio-group v-model="ClassPlanObj.isFirst">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="循环排课" label-width="80px" v-if="shwoTitle">
            <el-select
              placeholder="请选择循环排课类型"
              style="width: 100%"
              clearable
              v-model="ClassPlanObj.relativeTime"
            >
              <el-option
                style="margin-left: 10px"
                v-for="item in relativeTimes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <p v-if="shwoTitle">
            <el-form-item
              v-if="ClassPlanObj.relativeTime == 3"
              label="星期选择"
              label-width="80px"
            >
              <el-checkbox-group v-model="checkList" style="text-align: left">
                <el-checkbox label="1">周一</el-checkbox>
                <el-checkbox label="2">周二</el-checkbox>
                <el-checkbox label="3">周三</el-checkbox>
                <el-checkbox label="4">周四</el-checkbox>
                <el-checkbox label="5">周五</el-checkbox>
                <el-checkbox label="6">周六</el-checkbox>
                <el-checkbox label="7">周日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </p>
          <p v-if="shwoTitle">
            <el-form-item
              label="排课次数"
              style="text-align: left"
              label-width="80px"
              v-if="ClassPlanObj.relativeTime != 4"
            >
              <el-input-number
                v-model="ClassPlanObj.num"
                :min="0"
                :max="99999"
              ></el-input-number>
            </el-form-item>
          </p>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="classPlanDia = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" size="small" @click="SaveItem"
            >保存</el-button
          >
        </div>
      </el-dialog>
      <!-- 点击修改信息弹窗 -->
      <el-dialog
        id="oo"
        title="修改信息"
        :visible.sync="showDialog"
        :width="'40%'"
        class="custom-dialog"
      >
        <el-form ref="studentDatas" :model="studentDatas">
          <el-form-item label="姓名" label-width="80px">
            <el-input
              autocomplete="off"
              type="text"
              v-model="studentDatas.realname"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" label-width="80px">
            <!-- <el-input v-model="studentData.sex"></el-input> -->
            <el-radio-group
              class="pop"
              style="margin-left: -75%"
              v-model="studentDatas.sex"
            >
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="年级"
            style="text-align: left"
            label-width="80px"
          >
            <el-cascader
              clearable
              v-model="studentDatas.grades"
              :props="props"
              :options="gradeList"
              style="width: 100%"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="联系电话" label-width="80px">
            <el-input
              maxlength="11"
              v-model="studentDatas.telephone"
            ></el-input>
          </el-form-item>
          <el-form-item label="家庭住址" label-width="80px">
            <el-input v-model="studentDatas.address"></el-input>
          </el-form-item>
          <!-- <el-form-item label="跟进老师" label-width="80px">
            <el-select
              class="select"
              multiple
              clearable
              v-model="studentDatas.progressTeacherIds"
              placeholder="请选择跟进老师"
              style="width:100%;"
            >
              <el-option
                v-for="source in salesName"
                :key="source.id"
                :value="source.id"
                :label="source.realname"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false" size="small">取 消</el-button>
          <el-button type="primary" size="small" @click="submitForm()"
            >保存</el-button
          >
        </div>
      </el-dialog>

      <!-- 修改签约产品弹窗 -->
      <el-dialog
        id="ff"
        class="dialogClass"
        title="修改签约产品"
        :visible.sync="showVisibleDialog"
        :width="'55%'"
        :append-to-body="true"
      >
        <el-form ref="FormData" :model="FormData">
          <!-- <el-form-item label="开始日期" label-width="80px">
            <el-date-picker v-model="FormData.startTime" type="date" style="width: 100%;" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="有效期至" label-width="80px">
            <el-date-picker v-model="FormData.endTime" type="date" style="width: 100%;" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="课程" label-width="80px">
            <!-- <el-input v-model="FormData.categoryId"></el-input> -->
            <el-select
              class="select"
              clearable
              v-model="FormData.categoryId"
              placeholder="请选择课程"
              style="width: 100%"
            >
              <el-option
                v-for="source in courses"
                :key="source.id"
                :value="source.id"
                :label="source.categoryName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班型" label-width="80px">
            <el-select
              class="select"
              clearable
              v-model="FormData.classType"
              placeholder="请选择班型"
              style="width: 100%"
            >
              <el-option
                v-for="source in lessonList"
                :key="source.id"
                :value="source.id"
                :label="source.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进老师" label-width="80px">
            <el-select
              class="select"
              clearable
              v-model="FormData.teacherId"
              placeholder="请选择跟进老师"
              style="width: 100%"
            >
              <el-option
                v-for="source in teacherLists"
                :key="source.id"
                :value="source.id"
                :label="source.realname"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课节数" label-width="80px">
            <el-input v-model="FormData.lessonNum"></el-input>
          </el-form-item>
          <el-form-item label="课时单价" label-width="80px">
            <el-input v-model="FormData.lessonPrice"></el-input>
          </el-form-item>

          <el-form-item label="上课方式" label-width="80px">
            <el-select placeholder="请选择上课方式" v-model="FormData.educationType"  style="width: 100%" clearable filterable multiple>
              <el-option v-for="item in optionList4" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否为流失学员" label-width="120px">
            <el-radio v-model="radio" :label="1">是</el-radio>
            <el-radio
              v-model="radio"
              :label="2"
              @click.native="handleClickradio"
              >否</el-radio
            >
          </el-form-item>

          <el-form-item label="流失时间" label-width="80px" v-if="radio == 1">
            <el-date-picker
              v-model="ReasonsTime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="流失原因" label-width="80px" v-if="radio == 1">
            <el-input
              v-model="Reasons"
              type="textarea"
              placeholder="请输入内容"
              :autosize="{ minRows: 6, maxRows: 6 }"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="签约方案" label-width="80px">
            <el-radio @click.native.prevent="clickitem(item.id)" border v-model="FormData.contractId"
              style="width: 130px; height: 230px; margin-left:10px; margin-bottom: 20px; overflow: auto; max-height: 230px;"
              v-for="(item, index) in planArr" :key="index" :label='item.id'>
              <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
              <div style="text-align: left;" v-for="(item1, index1) in item.planList" :key="index1">
                <p>课节数:{{ item1.classNum }}</p>
                <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
              </div>
            </el-radio>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel" size="small">取 消</el-button>
          <el-button type="primary" size="small" @click="handleOkClick"
            >保存</el-button
          >
        </div>
      </el-dialog>

      <!-- 添加编辑学生成绩 -->
      <el-dialog
        :title="shwoTitles ? '添加考试成绩' : '编辑考试成绩'"
        :visible.sync="resultDialog"
        :before-close="resultDialogs"
        :width="'55%'"
      >
        <el-form>
          <el-form-item label="考试阶段" label-width="100px">
            <el-select
              class="select"
              clearable
              v-model="secondList.examStage"
              placeholder="请选择考试阶段"
              style="width: 100%"
            >
              <el-option
                v-for="source in secondstage"
                :key="source.value"
                :value="source.value"
                :label="source.text"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试时间" label-width="100px">
            <el-date-picker
              v-model="secondList.examTime"
              type="date"
              style="width: 100%"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="年级总人数" label-width="100px">
            <el-input v-model="secondList.gradeTotalPerson"></el-input>
          </el-form-item>
          <el-form-item label="班级总人数" label-width="100px">
            <el-input v-model="secondList.classTotalPerson"></el-input>
          </el-form-item>
          <el-form-item label="学校" label-width="100px">
            <el-input v-model="secondList.school"></el-input>
          </el-form-item>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
            "
            v-for="(item, index) in secondList.examList"
            :key="index"
          >
            <div style="width: 100%; text-align: left; line-height: 40px">
              {{ item.subject }}:
            </div>
            <el-form-item label="本次总成绩" label-width="120px">
              <el-input v-model="item.totalScore"></el-input>
            </el-form-item>
            <el-form-item label="本次考试成绩" label-width="120px">
              <el-input v-model="item.score"></el-input>
            </el-form-item>
            <el-form-item label="本次年级排名" label-width="120px">
              <el-input v-model="item.gradeRanking"></el-input>
            </el-form-item>
            <el-form-item label="本次班级排名" label-width="120px">
              <el-input v-model="item.classRanking"></el-input>
            </el-form-item>
            <el-form-item
              label="笔试成绩"
              label-width="120px"
              v-if="item.subject === '英语'"
            >
              <el-input v-model="item.writtenScore"></el-input>
            </el-form-item>
            <el-form-item
              label="听力成绩"
              label-width="120px"
              v-if="item.subject === '英语'"
            >
              <el-input v-model="item.listeningScore"></el-input>
            </el-form-item>
          </div>
          <!-- <el-form-item label="本次总成绩" label-width="100px">
            <el-input v-model="secondList.examScore" ></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resultDialogs" size="small">取 消</el-button>
          <el-button type="primary" size="small" @click="sbmitSecond"
            >保存</el-button
          >
        </div>
      </el-dialog>

      <!-- 学生成绩详情 -->
      <el-dialog
        title="学生成绩详情"
        :visible.sync="detailsResultDialog"
        :width="'55%'"
      >
        <el-table
          :data="rearchDetails"
          border
          style="width: 100%"
          @selection-change="changeSelection"
        >
          <el-table-column prop="subject" label="科目"> </el-table-column>
          <el-table-column prop="scoreStr" label="分数"> </el-table-column>
          <el-table-column prop="gradeRankStr" label="年排"> </el-table-column>
          <el-table-column prop="classRankStr" label="班排"> </el-table-column>
          <el-table-column prop="lastScore" label="上次考试分数">
          </el-table-column>
          <el-table-column prop="lastGradeRank" label="上次年排">
          </el-table-column>
          <el-table-column prop="lastClassRank" label="上次班排">
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="detailsResultDialog = false"
            size="small"
            >确定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        id="ff"
        class="dialogClass"
        title="新增或修改课消方案"
        :visible.sync="showDing"
        :width="'70%'"
        :append-to-body="true">

        <el-tabs v-model="isPlanShow" type="card" @tab-click="handleTabClick1">
          <el-tab-pane  style="float: left; margin-right: 10px; margin-bottom: 15px" label="课消方案(新)" name="oldPlan">
            <el-form ref="FormData" :model="FormData">
              <el-form-item label="课程" label-width="80px" v-if="handle">
                <el-select
                  class="select"
                  clearable
                  v-model="FormData.categoryId"
                  placeholder="请选择课程"
                  style="width: 100%"
                >
                  <el-option
                    v-for="source in courses"
                    :key="source.id"
                    :value="source.id"
                    :label="source.categoryName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班型" label-width="80px" v-if="handle">
                <el-select
                  class="select"
                  clearable
                  v-model="FormData.classType"
                  placeholder="请选择班型"
                  style="width: 100%"
                >
                  <el-option
                    v-for="source in lessonList"
                    :key="source.id"
                    :value="source.id"
                    :label="source.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="跟进老师" label-width="80px" v-if="handle">
                <el-select
                  class="select"
                  clearable
                  v-model="FormData.teacherId"
                  placeholder="请选择跟进老师"
                  style="width: 100%"
                >
                  <el-option
                    v-for="source in teacherLists"
                    :key="source.id"
                    :value="source.id"
                    :label="source.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="课节数" label-width="80px" v-if="handle">
                <el-input v-model="FormData.lessonNum"></el-input>
              </el-form-item>
              <el-form-item label="课时单价" label-width="80px" v-if="handle">
                <el-input v-model="FormData.lessonPrice"></el-input>
              </el-form-item>
              <el-form-item label="签约方案" label-width="80px">
                <!-- <el-radio   @click.native.prevent="clickitem(item.id)"   border  v-model="FormData.contractId"   style="  width: 130px;  height: 230px;  margin-left: 10px;  margin-bottom: 20px;  overflow: auto;   max-height: 230px;  "
                  v-for="(item, index) in planArr"  :key="index" :label="item.id">
                  <h3 style="margin-top: 0px">{{ item.planName }}</h3>
                  <div  style="text-align: left"  v-for="(item1, index1) in item.planList"  :key="index1" >
                    <p>课节数:{{ item1.classNum }}</p>
                    <p style="margin-bottom: 20px">课时单价:{{ item1.classPrice }}  </p>
                  </div>
                </el-radio> -->

                <div style="display: flex;flex-wrap: wrap; ">
                  <el-checkbox-group v-model="checkList1"  v-for="(item, index) in planArr"  :key="index" :label="item.id" style="margin-left: 10px;  margin-bottom: 20px;  border: 1px solid #e1dcdc; padding: 10px; border-radius: 10px;">
                    <el-checkbox :label="item.id" @change="handleChangecheckbox(item,index,$event)">
                      <h3 style="margin-top: 0px">{{ item.signContractName }}</h3>
                      <div style="margin-top: 0px" v-if="item.periodStartTime && item.periodEndTime">有效期:{{ item.periodStartTime }} - {{ item.periodEndTime }}</div>
                      <!-- <div  style="text-align: left"  v-for="(item1, index1) in item.planList"  :key="index1" >
                        <p>课节数:{{ item1.classNum }}</p>
                        <p style="margin-bottom: 20px">课时单价:{{ item1.classPrice }}  </p>
                      </div> -->
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane  style="float: left; margin-left: 10px; margin-bottom: 15px"   label="课消方案(旧)" name="newPlan">
            <el-form ref="FormData" :model="FormData">
              <el-form-item label="课程" label-width="80px" v-if="handle">
                <el-select
                  class="select"
                  clearable
                  v-model="FormData.categoryId"
                  placeholder="请选择课程"
                  style="width: 100%"
                >
                  <el-option
                    v-for="source in courses"
                    :key="source.id"
                    :value="source.id"
                    :label="source.categoryName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班型" label-width="80px" v-if="handle">
                <el-select
                  class="select"
                  clearable
                  v-model="FormData.classType"
                  placeholder="请选择班型"
                  style="width: 100%"
                >
                  <el-option
                    v-for="source in lessonList"
                    :key="source.id"
                    :value="source.id"
                    :label="source.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="跟进老师" label-width="80px" v-if="handle">
                <el-select
                  class="select"
                  clearable
                  v-model="FormData.teacherId"
                  placeholder="请选择跟进老师"
                  style="width: 100%"
                >
                  <el-option
                    v-for="source in teacherLists"
                    :key="source.id"
                    :value="source.id"
                    :label="source.realname"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="课节数" label-width="80px" v-if="handle">
                <el-input v-model="FormData.lessonNum"></el-input>
              </el-form-item>
              <el-form-item label="课时单价" label-width="80px" v-if="handle">
                <el-input v-model="FormData.lessonPrice"></el-input>
              </el-form-item>
              <el-form-item label="签约方案" label-width="80px">
                <!-- <el-radio
                  @click.native.prevent="clickitem(item.id)"
                  border
                  v-model="FormData.contractId"
                  style="
                    width: 130px;
                    height: 230px;
                    margin-left: 10px;
                    margin-bottom: 20px;
                    overflow: auto;
                    max-height: 230px;
                  "
                  v-for="(item, index) in planArr"
                  :key="index"
                  :label="item.id"
                >
                  <h3 style="margin-top: 0px">{{ item.planName }}</h3>
                  <div
                    style="text-align: left"
                    v-for="(item1, index1) in item.planList"
                    :key="index1"
                  >
                    <p>课节数:{{ item1.classNum }}</p>
                    <p style="margin-bottom: 20px">
                      课时单价:{{ item1.classPrice }}
                    </p>
                  </div>
                </el-radio> -->

                <div style="display: flex;flex-wrap: wrap;  ">
                  <el-checkbox-group v-model="checkList2"  v-for="(item, index) in planArr1"  :key="index" :label="item.id" style="margin-left: 10px;  margin-bottom: 20px;  border: 1px solid #e1dcdc; padding: 10px; border-radius: 10px;">
                    <el-checkbox :label="item.id" @change="handleChangecheckbox1(item,index,$event)">
                      <h3 style="margin-top: 0px">{{ item.planName }}</h3>
                      <div style="margin-top: 0px" v-if="item.periodStartTime && item.periodEndTime">有效期:{{ item.periodStartTime }} - {{ item.periodEndTime }}</div>
                      <div  style="text-align: left"  v-for="(item1, index1) in item.planList"  :key="index1" >
                        <p>课节数:{{ item1.classNum }}</p>
                        <p style="margin-bottom: 20px">课时单价:{{ item1.classPrice }}  </p>
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>


              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>


        <!-- <el-form ref="FormData" :model="FormData">
          <el-form-item label="课程" label-width="80px" v-if="handle">
            <el-select
              class="select"
              clearable
              v-model="FormData.categoryId"
              placeholder="请选择课程"
              style="width: 100%"
            >
              <el-option
                v-for="source in courses"
                :key="source.id"
                :value="source.id"
                :label="source.categoryName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班型" label-width="80px" v-if="handle">
            <el-select
              class="select"
              clearable
              v-model="FormData.classType"
              placeholder="请选择班型"
              style="width: 100%"
            >
              <el-option
                v-for="source in lessonList"
                :key="source.id"
                :value="source.id"
                :label="source.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进老师" label-width="80px" v-if="handle">
            <el-select
              class="select"
              clearable
              v-model="FormData.teacherId"
              placeholder="请选择跟进老师"
              style="width: 100%"
            >
              <el-option
                v-for="source in teacherLists"
                :key="source.id"
                :value="source.id"
                :label="source.realname"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课节数" label-width="80px" v-if="handle">
            <el-input v-model="FormData.lessonNum"></el-input>
          </el-form-item>
          <el-form-item label="课时单价" label-width="80px" v-if="handle">
            <el-input v-model="FormData.lessonPrice"></el-input>
          </el-form-item>
          <el-form-item label="签约方案" label-width="80px">
            <el-radio
              @click.native.prevent="clickitem(item.id)"
              border
              v-model="FormData.contractId"
              style="
                width: 130px;
                height: 230px;
                margin-left: 10px;
                margin-bottom: 20px;
                overflow: auto;
                max-height: 230px;
              "
              v-for="(item, index) in planArr"
              :key="index"
              :label="item.id"
            >
              <h3 style="margin-top: 0px">{{ item.planName }}</h3>
              <div
                style="text-align: left"
                v-for="(item1, index1) in item.planList"
                :key="index1"
              >
                <p>课节数:{{ item1.classNum }}</p>
                <p style="margin-bottom: 20px">
                  课时单价:{{ item1.classPrice }}
                </p>
              </div>
            </el-radio>
          </el-form-item>
        </el-form> -->

        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel1" size="small">取 消</el-button>
          <!-- <el-button type="primary" size="small" @click="handleOkClick1">保存</el-button> -->
          <el-button type="primary" size="small" @click="handleOkClick2">保存</el-button>
        </div>
      </el-dialog>

      <!--新加签约弹窗 -->
      <contract-products
        ref="contractProducts"
        :id="id1"
        @refresh="refresh"
      ></contract-products>
    </div>

    <el-dialog
      append-to-body
      title="请输入删除原因"
      :visible.sync="dialogdeleteCause"
      :width="'55%'"
      :before-close="handleclick2"
    >
      <div>
        <el-input
          :autosize="{ minRows: 6, maxRows: 6 }"
          type="textarea"
          placeholder="请输入删除原因"
          v-model="deleteCause"
          maxlength="200"
          show-word-limit
        >
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleclick2" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="handleclick1"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      append-to-body
      title="提示"
      :visible.sync="dialogdeleteCause1"
      :width="'55%'"
    >
      <div>{{ dialogdeleteCauseMessage }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogdeleteCause1 = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="handleclick12"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="预览MP3"
      width="50%"
      style="padding: 0px 50px; height: 50vh"
      :visible.sync="showInfosMpsHOW3"
      :before-close="showshowInfoViewInfoClers3"
      :close-on-click-modal="false"
    >
      <audio controls>
        <source :src="showInfosMp3" type="audio/ogg" />
        <source :src="showInfosMp3" type="audio/mpeg" />
        您的浏览器不支持音频。
      </audio>
    </el-dialog>

    <el-dialog
      title="预览图片"
      width="80%"
      style="padding: 0px 50px; height: 80vh"
      :visible.sync="showInfoss"
      :before-close="showshowInfoViewInfoClers5"
      :close-on-click-modal="false"
    >
      <img :src="urls" :alt="urls" style="width: 80%" />
    </el-dialog>

    <el-dialog
      append-to-body
      title="待办任务"
      :visible.sync="dialogToDoTasks"
      :width="'80%'"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <agencyTasks
        :itmesID="itmesID"
        :showType="showType"
        v-if="dialogToDoTasks"
      ></agencyTasks>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogToDoTasks = false" size="small"
          >关闭</el-button
        >
      </div>
    </el-dialog>

    <el-drawer
      title="电话沟通"
      :append-to-body="true"
      :before-close="handleCloseTelephone"
      :visible.sync="telephoneDrawer"
      size="30%"
    >
      <el-button
        v-if="isBtn"
        type="primary"
        icon="el-icon-plus"
        style="width: 98%; margin-left: 5px"
        @click="handleClickAdd"
        >添加电话沟通</el-button
      >

      <div
        style="
          font-size: 14px;
          border: 1px solid rgb(204 197 197);
          border-radius: 8px;
          width: 97%;
          margin-top: 40px;
          margin-left: 9px;
          padding: 8px;
          overflow-y: auto;
          height: 75vh;
        "
      >
        <div
          class="boxshadow"
          style="margin-bottom: 20px"
          v-for="(item, index) in telephoneList"
          :key="index + 'ABC'"
        >
          <div
            style="
              color: #fff;
              padding: 10px 0px;
              background: #95d1e8;
              padding-left: 10px;
              border-radius: 5px;
              margin-bottom: 10px;
              display: flex;
              justify-content: space-between;
            "
          >
            <span>第{{ index + 1 }}次电话</span>
            <i
              class="el-icon-circle-close"
              style="margin-top: 4px; margin-right: 10px"
              @click="handleClickRend(index)"
            ></i>
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px">预约时间:</div>
            <el-date-picker
              v-model="item.appointmentTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              style="width: 100%"
              placeholder="选择日期"
            ></el-date-picker>
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px">实际沟通时间:</div>
            <el-date-picker
              v-model="item.communicationTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              style="width: 100%"
              placeholder="选择日期"
            ></el-date-picker>
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px">沟通录音:</div>
            <el-button
              style="width: 45%"
              icon="el-icon-plus"
              type="primary"
              size="small"
              @click="handleUpload('录音', item, index)"
              >点击上传</el-button
            >
            <el-button
              style="width: 45%"
              icon="el-icon-view"
              type="primary"
              size="small"
              @click="handleUpload('查看录音', item, index)"
              >查看录音</el-button
            >
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px">沟通截图:</div>
            <el-button
              style="width: 45%"
              icon="el-icon-plus"
              type="primary"
              size="small"
              @click="handleUpload('截图', item, index)"
              >点击上传</el-button
            >
            <el-button
              style="width: 45%"
              icon="el-icon-view"
              type="primary"
              size="small"
              @click="handleUpload('查看截图', item, index)"
              >查看截图</el-button
            >
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px">沟通人:</div>
            <el-select
              v-model="item.communicationPerson"
              multiple
              filterable
              clearable
              placeholder="请选择沟通人"
              style="width: 100%"
            >
              <el-option
                v-for="(e, i) in options"
                :key="i + 'INIT'"
                :label="e.realname"
                :value="e.id"
              >
              </el-option>
            </el-select>
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px">沟通目的:</div>
            <el-input
              v-model="item.communicationGoal"
              type="textarea"
              show-word-limit
              placeholder="请输入沟通目的"
              :autosize="{ minRows: 6, maxRows: 6 }"
            ></el-input>
          </div>

          <div style="margin-bottom: 20px; display: flex">
            <div style="width: 150px; margin-top: 4px" class="remark">
              备注:
            </div>
            <el-input
              v-model="item.remark"
              type="textarea"
              show-word-limit
              placeholder="请输入备注"
              :autosize="{ minRows: 6, maxRows: 6 }"
            ></el-input>
          </div>

          <div style="text-align: end; margin-bottom: 15px; padding-top: 25px">
            <el-button
              size="small"
              type="primary"
              @click="handleCloseTelephoneSubt(item, index)"
              >保存</el-button
            >
          </div>
        </div>
      </div>

      <div style="position: fixed; bottom: 10px; right: 10px">
        <el-button size="small" @click="rejectDialogShowClr">关闭</el-button>
      </div>
    </el-drawer>

    <Elupload
      v-if="isShowElupload"
      @handleEventElUpload="handleEventElUpload"
      @handleEventElUploadSubt="handleEventElUploadSubt"
      :Uploadtypes="Uploadtypes"
      :fileAllLists="fileAllLists"
    ></Elupload>



      <el-dialog  title="有效期" :visible="centerDialogVisible"  width="40%"  center :before-close="handlecenterDialogVisiblecCle">
          <el-date-picker v-if="centerDialogVisible" style="width: 100%;"  value-format="yyyy-MM-dd" v-model="time" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handlecenterDialogVisiblecCle">取 消</el-button>
            <el-button type="primary" @click="handlecenterDialogVisible">确 定</el-button>
          </span>
      </el-dialog>


      <el-dialog  title="有效期" :visible="centerDialogVisible1"  width="40%"  center :before-close="handlecenterDialogVisiblecCle1">
          <el-date-picker v-if="centerDialogVisible1" style="width: 100%;"  value-format="yyyy-MM-dd" v-model="time1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handlecenterDialogVisiblecCle1">取 消</el-button>
            <el-button type="primary" @click="handlecenterDialogVisible1">确 定</el-button>
          </span>
      </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import ContractProducts from "./ContractProducts.vue";
import agencyTasks from ".././assembly/agencyTasks";
import { getTeachers } from "@/api/feedBackApi";
import Elupload from "../.././customerManagement/Elupload";

export default {
  props: ["id","peagNum"],
  components: {
    ContractProducts, //新加产品
    // ModifyProduct //修改产品
    agencyTasks,
    Elupload,

  },
  data() {
    return {
      optionList4: [{ id: 1, name: '网课' }, { id: 2, name: '上门' }, { id: 3, name: '门店' }],
      time:[],
      time1:[],
      centerDialogVisible:false,
      centerDialogVisible1:false,
      isPlanShow:'oldPlan',
      itmesID: "",
      showType: true,
      dialogToDoTasks: false,
      showInfosMpsHOW3: false,
      showInfoss: false,

      showInfosMp3: "",
      urls: "",

      input1: [],
      input2: [],
      input3: [],
      input4: "",

      rearchDetails: [],
      searchRow: {},
      secondListData: [],
      detailsResultDialog: false,
      secondstage: [
        { text: "诊断成绩", value: 1 },
        { text: "开学考", value: 2 },
        { text: "月考", value: 3 },
        { text: "期中考", value: 4 },
        { text: "期末考", value: 5 },
      ],
      resultList: {
        pageSize: 10,
        pageNo: 1,
        examStage: "",
        timers: "",
        total: "",
      },

      secondList: {
        examStage: "",
        examTime: "",
        examScore: "",
        examDetails: "",
        gradeTotalPerson: "",
        classTotalPerson: "",
        school: "",
        examList: [
          {
            subject: "语文",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "数学",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "英语",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
            writtenScore: "",
            listeningScore: "",
          },
          {
            subject: "历史",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "地理",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "生物",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "政治",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "物理",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "化学",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
        ],
      },

      shwoTitles: true,
      findStudentHour: {},
      radio: 0,
      ReasonsTime: null,
      Reasons: "",
      handle: false,
      serachObj: {
        nums: 1,
        pageSize: 10,
        pageNo: 1,
        createTimes: [],
        startDate: "",
        endDate: "",
        studentId: this.id,
        teacherId: "",
        categoryId: "",
        educationType: "",
        classEnding: "",
      },
      batchDelArr: [],
      shwoTitle: true,
      className: [],
      classTeacher: [],
      educationType: [
        { value: 1, name: "已结课" },
        { value: 2, name: "未结课" },
      ],
      educationType1: [
        { value: 0, name: "未完成" },
        { value: 1, name: "进行中" },
        { value: 2, name: "已完成" },
      ],
      classEnding: [
        { value: 1, name: "网课" },
        { value: 2, name: "上门" },
        { value: 3, name: "门店" },
      ],
      relativeTimes: [
        {
          value: "1",
          label: "每天",
        },
        {
          value: "2",
          label: "每周",
        },
        {
          value: "3",
          label: "自定义",
        },
        {
          value: "4",
          label: "无",
        },
      ],
      checkList: [],
      checkList1: [],
      checkList2: [],
      ClassPlanObj: {
        courseDate: "",
        isFirst: "",
        educationType: 2,
        relativeTime: "4",
        courseId: "",
        num: 0,
        courseTimeOn: "",
        courseEndTime: "",
        categoryId: "",
        checkList: [],
        teacherId: "",
        studentId: this.id,

        courseSchedulingNo: 1,
        classId: 1,
        classroom: "一教室",
        numberOfClassDeductions: 0,
        recurrentScheduling: 0,
        canMakeAnAppointment: 0,
        courseNotes: "备注：赶紧上课思密达",
      },
      studentName: "",
      classPlanDia: false,
      resultDialog: false,
      tableData: [],
      totalAll: 0,
      keys: 0,
      gradeList: [],
      uuid: "",
      props: {
        label: "gradeName",
        children: "children",
        value: "id",
      },
      teacherLists: [], //所有老师
      id2: "",
      id1: this.id,
      studentData: {
        gradeStr: "",
        progressTeacherName: "",
        realname: "",
        sex: "",
        telephone: "",
        grade: [],
        // grades: [],
        email: "",
        address: "",
        age: "",
        progressTeacherIds: [],
        teacherId: "",
      },
      studentDatas: {
        teacherId: "", //跟进老师
        progressTeacherName: [],
        realname: "",
        sex: "",
        sexStr: "",
        telephone: "",
        // grade: [],
        grades: [],
        email: "",
        address: "",
        age: "",
        progressTeacherIds: [],
      },
      salesName: [],
      isShow: false,
      name: "",
      studentList: [],
      list: [], //签约列表
      productData: [],
      prouctCheck: [],
      courseList: [],
      countList: [],
      planArr: [],
      planArr1: [],
      activeName: "classPlan",
      showDialog: false, //修改信息
      dialogVisible: false, //签约产品
      showVisibleDialog: false,
      FormData: {
        contractId: "",
        categoryId: "",
        id: "",
        startTime: "",
        classType: "",
        lessonNum: "",
        lessonPrice: "",
        endTime: "",
        categoryName: "",
        teacherId: "",
        educationType:[]
      },
      lessonList: [
        {
          id: 1,
          name: "1v1",
        },
        {
          id: 2,
          name: "1v2",
        },
        {
          id: 3,
          name: "1v3",
        },
      ],
      requestParameters: {
        pageSize: 10000, //每页多少条
        pageNum: 1, //当前显示页码
      },
      paging: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },
      courses: [],
      isShows: true,
      showDing: 0,
      contractId: "",
      dialogdeleteCause: false,
      deleteCause: "",

      dialogdeleteCause1: false,
      dialogdeleteCauseMessage: "",

      pageNums: 1,
      pageSizes: 10,
      totals: 0,
      communicationListData: [],

      telephoneDrawer: false,
      telephoneList: [
        {
          appointmentTime: "",
          communicationTime: "",
          communicationRecord: [],
          screenshot: [],
          communicationGoal: "",
          remark: "",
          communicationPerson: [],
        },
      ],

      isShowElupload: false,
      fileAllLists: [],

      options: [],
      isBtn: true,

      index:0,
      index1:1,

      isCyop:[],

    };
  },
  computed: {
    // jobStatusText () {
    //   return this.studentData.sex + '' === 1 ? "男" : "女";
    // }
  },
  created() {
    //
    //
    this.allStudent();
    this.getTeacher();
    this.getStudentDetails();
    this.getStudentStatistics();
    this.getProductList();
    this.fetchCourses();
    this.getTeacherList();
    this.getGrade();
    this.getAllPlan();
    this.getListData();
    this.getAllTeacher();
    this.getExamList();
  },

  mounted() {
    axios
      .post(
        `${apiBaseUrl}/student/findStudentHour`,
        { id: this.id },
        { headers: { authorization: sessionStorage.getItem("tokenInfo") } }
      )
      .then((res) => {
        let data = res.data.data;
        this.findStudentHour = data;
      });

    const telephoneCommunication = window.sessionStorage.getItem(
      "telephoneCommunication"
    );
    if (telephoneCommunication === "telephoneCommunication") {
      this.activeName = "telephoneCommunication";
      this.handleSearchBtn1();
    } else {
      this.activeName = "classPlan";
    }

    getTeachers().then((res) => {
      this.options = res.data;
    });


  },

  methods: {

    handleChangecheckbox(itme,index,e){


      if(e){

        this.typeTimeis = true
        this.typeTimeis1 = false

        this.index = index
        this.centerDialogVisible = true
      }

    },

    handleChangecheckbox1(itme,index,e){
      if(e){

        this.typeTimeis = false
        this.typeTimeis1 = true

        this.index1 = index
        this.centerDialogVisible1 = true
      }

    },

    handleCloseTelephoneSubt(itme, index) {
      if (itme.remark) {
        if (itme.id) {
          // itme.questionnaireId = itme.id

          if (
            itme.communicationRecord &&
            Array.isArray(itme.communicationRecord)
          ) {
            itme.communicationRecord = JSON.stringify(itme.communicationRecord);
          } else {
            itme.communicationRecord = "";
          }

          if (itme.screenshot && Array.isArray(itme.screenshot)) {
            itme.screenshot = JSON.stringify(itme.screenshot);
          } else {
            itme.screenshot = "";
          }

          if (itme.communicationPerson && itme.communicationPerson.length > 0) {
            itme.communicationPerson = itme.communicationPerson.join(",");
          } else {
            itme.communicationPerson = "";
          }

          itme.studentId = this.id;

          axios
            .post(`${apiBaseUrl}/wx_questionnaire/updateCommunication`, itme, {
              headers: { authorization: sessionStorage.getItem("tokenInfo") },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({ type: "success", message: "修改成功~" });
                this.handleSearchBtn1();
                this.rejectDialogShowClr();
              } else {
                this.$message({ type: "error", message: "修改失败~" });
              }
            });
        } else {
          if (
            itme.communicationRecord &&
            Array.isArray(itme.communicationRecord)
          ) {
            itme.communicationRecord = JSON.stringify(itme.communicationRecord);
          } else {
            itme.communicationRecord = "";
          }

          if (itme.screenshot && Array.isArray(itme.screenshot)) {
            itme.screenshot = JSON.stringify(itme.screenshot);
          } else {
            itme.screenshot = "";
          }

          if (itme.communicationPerson && itme.communicationPerson.length > 0) {
            itme.communicationPerson = itme.communicationPerson.join(",");
          } else {
            itme.communicationPerson = "";
          }

          itme.studentId = this.id;

          axios
            .post(`${apiBaseUrl}/wx_questionnaire/addCommunication`, itme, {
              headers: { authorization: sessionStorage.getItem("tokenInfo") },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({ type: "success", message: "添加成功~" });
                this.handleSearchBtn1();
                this.rejectDialogShowClr();
              } else {
                this.$message({ type: "error", message: "添加失败~" });
              }
            });
        }
      }else{
        this.$message({ type: "warning", message: "请填写备注~" });
      }
    },

    handleEventElUploadSubt(flileList) {
      this.isShowElupload = false;
      if (flileList && flileList.length > 0) {
        this.fileAllLists = flileList;
        if (this.Uploadtypes === "查看录音" || this.Uploadtypes === "录音") {
          this.telephoneList[this.indexItme].communicationRecord =
            this.fileAllLists;
        }

        if (this.Uploadtypes === "查看截图" || this.Uploadtypes === "截图") {
          this.telephoneList[this.indexItme].screenshot = this.fileAllLists;
        }
      }

      this.fileAllLists = [];
    },

    handleEventElUpload(flileList) {
      this.isShowElupload = false;
    },

    handleClickRend(index) {
      this.telephoneList.splice(index, 1);
    },

    handleClickAdd() {
      this.telephoneList.push({
        appointmentTime: "",
        communicationTime: "",
        communicationRecord: [],
        screenshot: [],
        communicationGoal: "",
        remark: "",
        communicationPerson: [],
      });
    },

    handleCloseTelephone() {
      this.telephoneDrawer = false;
    },
    handlecenterDialogVisiblecCle() {
      this.time = []
      this.centerDialogVisible = false
    },
    handlecenterDialogVisiblecCle1() {
      this.time1 = []
      this.centerDialogVisible1 = false
    },
    handlecenterDialogVisible(){

        this.planArr[this.index].periodStartTime = this.time[0]
        this.planArr[this.index].periodEndTime = this.time[1]

        this.time = []
        this.centerDialogVisible = false
    },
    handlecenterDialogVisible1(){

        this.planArr1[this.index1].periodStartTime = this.time1[0]
        this.planArr1[this.index1].periodEndTime = this.time1[1]

        this.time1 = []
        this.centerDialogVisible1 = false
    },

    handleUpload(type, itme, index) {
      this.Uploadtypes = type;
      this.indexItme = index;
      this.fileAllLists = [];

      if (type === "录音" || type === "查看录音") {
        if (itme.communicationRecord) {
          this.fileAllLists = itme.communicationRecord;
        } else {
          this.fileAllLists = [];
        }
      }

      if (type === "截图" || type === "查看截图") {
        if (itme.screenshot) {
          this.fileAllLists = itme.screenshot;
        } else {
          this.fileAllLists = [];
        }
      }

      this.isShowElupload = true;
    },

    handleAmend(type, item) {
      if (type === "添加") {
        this.telephoneList = [];
        this.isBtn = true;
        this.telephoneDrawer = true;
      }

      if (type === "修改") {
        this.isBtn = false;



        if (Array.isArray(item.communicationPerson)) {
          item.communicationPerson = item.communicationPerson.map(Number);
        } else {
          item.communicationPerson = item.communicationPerson
            .split(",")
            .map(Number);
        }
        this.telephoneList[0].communicationPerson = item.communicationPerson;
        this.telephoneList[0].appointmentTime = item.appointmentTime;
        this.telephoneList[0].communicationTime = item.communicationTime;
        this.telephoneList[0].communicationGoal = item.communicationGoal;
        this.telephoneList[0].remark = item.remark;
        this.telephoneList[0].communicationRecord = item.communicationRecord;
        this.telephoneList[0].screenshot = item.screenshot;
        this.telephoneList[0].id = item.id;

        this.telephoneDrawer = true;
      }
    },

    handleView1(e) {
      this.showInfosMp3 = e.url;
      this.showInfosMpsHOW3 = true;
    },
    handleView2(e) {
      this.urls = e.url;
      this.showInfoss = true;
    },

    showshowInfoViewInfoClers3() {
      this.showInfosMp3 = "";
      this.showInfosMpsHOW3 = false;
    },

    showshowInfoViewInfoClers5() {
      this.urls = "";
      this.showInfoss = false;
    },

    handleclick1() {
      let admin = {};
      if (localStorage.getItem("admin")) {
        admin = JSON.parse(localStorage.getItem("admin"));
      }
      if (this.deleteCause) {
        let data = {
          deleteCause: this.deleteCause,
          delPersonId: admin.id,
          scheduleIds: this.batchDelArr,
        };
        axios
          .post(`${apiBaseUrl}/schedule/delbatchbystudent`, data, {
            headers: {
              authorization: sessionStorage.getItem("tokenInfo"),
            },
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.deleteCause = "";
              this.dialogdeleteCause = false;
              this.$message.success(res.data.message);
              this.getListData();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((error) => {
            this.$message({ message: "保持失败", type: "error" });
            console.error(error);
          });
      } else {
        this.$message({ message: "请输入删除原因", type: "warning" });
      }
    },
    handleclick12() {
      this.dialogdeleteCause = true;
    },
    handleclick2() {
      this.dialogdeleteCause = false;
      this.deleteCause = "";
    },

    handleClickradio() {
      this.ReasonsTime = null;
      this.Reasons = "";
    },

    rejectDialogShowClr() {
      this.telephoneDrawer = false;
    },

    clearBtn() {
      this.serachObj.createTimes = [];
      (this.serachObj.startDate = ""),
        (this.serachObj.endDate = ""),
        (this.serachObj.teacherId = ""),
        (this.serachObj.categoryId = ""),
        (this.serachObj.educationType = ""),
        (this.serachObj.classEnding = ""),
        this.getStudentDetails();
    },
    searchBtn() {
      this.serachObj.pageNo = 1;
      this.serachObj.nums = 1;
      this.getStudentDetails();
    },
    handleSearchBtn() {
      this.serachObj.startDate = this.serachObj.createTimes[0];
      this.serachObj.endDate = this.serachObj.createTimes[1];
      let obj = {
        startDate: this.serachObj.createTimes[0]
          ? this.serachObj.createTimes[0]
          : "",
        endDate: this.serachObj.createTimes[1]
          ? this.serachObj.createTimes[1]
          : "",
        classEnding: this.serachObj.classEnding,
        educationType: this.serachObj.educationType,
        categoryId: this.serachObj.categoryId,
        studentId: this.serachObj.studentId,
        teacherId: this.serachObj.teacherId,
      };
      axios
        .post(`${apiBaseUrl}/schedule/selectscheduleByStudent`, obj, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          this.tableData = res.data.data.records;
          this.totalAll = res.data.data.total;
          if (res.data.code == 200) {
            this.$message({ message: "查询成功", type: "success" });
          }
        })
        .catch((err) => {

        });
    },
    handleClearBtn() {
      (this.serachObj.createTimes = ""),
        (this.serachObj.startDate = ""),
        (this.serachObj.endDate = ""),
        (this.serachObj.teacherId = ""),
        (this.serachObj.categoryId = ""),
        (this.serachObj.educationType = ""),
        (this.serachObj.classEnding = "");
      this.getListData();
      this.handleSearchBtn1();
    },
    handleTabClick() {
      this.handleClearBtn();
    },
    handleTabClick1() {

    },
    getAllTeacher() {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        }) // 请替换为你的API URL
        .then((res) => {
          this.classTeacher = res.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    handleSearchBtn1() {
      let data = {
        appointmentStartTime: this.input1[0] || "",
        appointmentEndTime: this.input1[1] || "",
        communicationStartTime: this.input2[0] || "",
        communicationEndTime: this.input2[1] || "",
        communicationPerson: this.input3.join(","),
        completePlan: this.input4,
        studentId: this.id,
        pageNum: this.pageNums,
        pageSize: this.pageSizes,
      };
      axios
        .post(`${apiBaseUrl}/communication/findPage`, data, {
          headers: { authorization: sessionStorage.getItem("tokenInfo") },
        })
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.data.records && res.data.data.records.length > 0) {
              res.data.data.records.forEach((itme) => {
                if (itme.communicationRecord) {
                  itme.communicationRecord = JSON.parse(
                    itme.communicationRecord
                  );
                }

                if (itme.screenshot) {
                  itme.screenshot = JSON.parse(itme.screenshot);
                }
              });

              this.communicationListData = res.data.data.records;
              this.totals = res.data.data.total;
              this.pageSizes = res.data.data.size;
              this.pageNums = res.data.data.pages;
            } else {
              this.communicationListData = [];
              this.totals = 0;
              this.pageSizes = 10;
              this.pageNums = 1;
            }
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    handleClearBtn1() {
      this.input1 = [];
      this.input2 = [];
      this.input3 = [];
      this.input4 = "";
      this.handleSearchBtn1();
    },

    deleItem(id) {
      axios
        .delete(`${apiBaseUrl}/schedule/delete/${id}`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        }) // 请替换为你的API URL
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.getListData();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    editItem(row) {
      this.shwoTitle = false;
      this.classPlanDia = true;
      axios
        .get(
          `${apiBaseUrl}/schedule/getScheduleDtoByStudentId?scheduleId=${row.scheduleId}&studentId=${this.id}`,
          {
            headers: {
              authorization: sessionStorage.getItem("tokenInfo"),
            },
          }
        ) // 请替换为你的API URL
        .then((res) => {
          //
          this.ClassPlanObj = res.data.data;
          this.ClassPlanObj.relativeTime = res.data.data.relativeTime + "";
          this.checkList = res.data.data.checkList;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    editSecond(tepy, row) {

      if (tepy === "add") {
        this.shwoTitles = true;
        this.resultDialog = true;
      } else if (tepy === "details") {
        this.detailsResultDialog = true;
        axios
          .get(`${apiBaseUrl}/exam/examDetail/${row.id}`, {
            headers: { authorization: sessionStorage.getItem("tokenInfo") },
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.rearchDetails = res.data.data.examList;
            }
          });
      } else {
        // this.searchRow = row
        this.shwoTitles = false;
        this.resultDialog = true;
        axios
          .get(`${apiBaseUrl}/exam/examDetail/${row.id}`, {
            headers: { authorization: sessionStorage.getItem("tokenInfo") },
          })
          .then((res) => {
            if (res.data.code === 200) {
              // this.rearchDetails = res.data.data.examList
              this.secondList.id = res.data.data.id;
              this.secondList.examStage = res.data.data.examStage;
              this.secondList.examTime = res.data.data.examTime;
              this.secondList.examScore = res.data.data.examScore;
              this.secondList.gradeTotalPerson = res.data.data.gradeTotalPerson;
              this.secondList.classTotalPerson = res.data.data.classTotalPerson;
              this.secondList.school = res.data.data.school;
              this.secondList.examList = res.data.data.examList;
            }
          });
      }
    },
    resultDialogs() {
      this.resultDialog = false;
      this.secondList = {
        examStage: "",
        examTime: "",
        examScore: "",
        examDetails: "",
        gradeTotalPerson: "",
        classTotalPerson: "",
        school: "",
        examList: [
          {
            subject: "语文",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "数学",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "英语",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "历史",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "地理",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "生物",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "政治",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "物理",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
          {
            subject: "化学",
            score: "",
            totalScore: "",
            gradeRanking: "",
            classRanking: "",
          },
        ],
      };
    },
    sbmitSecond() {
      this.resultDialog = false;
      if (this.shwoTitles) {
        let data = {
          studentId: this.id,
          examStage: this.secondList.examStage,
          examTime: this.secondList.examTime,
          // examScore:this.secondList.examScore,
          gradeTotalPerson: this.secondList.gradeTotalPerson,
          classTotalPerson: this.secondList.classTotalPerson,
          school: this.secondList.school,
          examDetails: JSON.stringify(this.secondList.examList),
        };

        axios
          .post(`${apiBaseUrl}/exam/add`, data, {
            headers: { authorization: sessionStorage.getItem("tokenInfo") },
          })
          .then((res) => {

            this.secondList = {
              examStage: "",
              examTime: "",
              examScore: "",
              examDetails: "",
              gradeTotalPerson: "",
              classTotalPerson: "",
              school: "",
              examList: [
                {
                  subject: "语文",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "数学",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "英语",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "历史",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "地理",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "生物",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "政治",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "物理",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "化学",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
              ],
            };
            if (res.data.code === 200) {
              this.$message.success(res.data.message);
              this.getExamList();
            } else {
              this.$message.error(res.data.message);
            }
          });
      } else {
        let data = {
          id: this.secondList.id,
          studentId: this.id,
          examStage: this.secondList.examStage,
          examTime: this.secondList.examTime,
          // examScore:this.secondList.examScore,
          gradeTotalPerson: this.secondList.gradeTotalPerson,
          classTotalPerson: this.secondList.classTotalPerson,
          school: this.secondList.school,
          examDetails: JSON.stringify(this.secondList.examList),
        };

        axios
          .put(`${apiBaseUrl}/exam/updateExam`, data, {
            headers: { authorization: sessionStorage.getItem("tokenInfo") },
          })
          .then((res) => {
            this.secondList = {
              examStage: "",
              examTime: "",
              examScore: "",
              examDetails: "",
              gradeTotalPerson: "",
              classTotalPerson: "",
              school: "",
              examList: [
                {
                  subject: "语文",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "数学",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "英语",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "历史",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "地理",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "生物",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "政治",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "物理",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
                {
                  subject: "化学",
                  score: "",
                  totalScore: "",
                  gradeRanking: "",
                  classRanking: "",
                },
              ],
            };
            if (res.data.code === 200) {
              this.$message.success(res.data.message);
              this.getExamList();
            } else {
              this.$message.error(res.data.message);
            }
          });
      }
    },
    batchDel() {
      // let scheduleIds = this.batchDelArr
      // axios
      //   .post(`${apiBaseUrl}/schedule/delbatchbystudent`, scheduleIds,{
      //     headers:{
      //       'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      //   }) // 请替换为你的API URL
      //   .then(res => {
      //     if (res.data.code == 200) {
      //       this.$message.success(res.data.message)
      //       this.getListData()
      //     } else {
      //       this.$message.error(res.data.message)
      //     }
      //   })
      //   .catch(error => {
      //     this.$message({ message: "删除失败", type: "error" });
      //   });
      if (this.batchDelArr.length > 0) {
        //  this.dialogdeleteCause = true

        let data = {
          scheduleIds: "" + "[" + this.batchDelArr + "]",
          deleteMethod: 3,
        };
        axios
          .post(`${apiBaseUrl}/schedule/getDelInspectionPlan`, data, {
            headers: { authorization: sessionStorage.getItem("tokenInfo") },
          })
          .then((res) => {
            if (res.data.message === "true") {
              this.dialogdeleteCause = true;
            } else {
              this.dialogdeleteCauseMessage = res.data.message;
              this.dialogdeleteCause1 = true;
            }
          });
      } else {
        this.$message({ message: "请选择课程", type: "warning" });
      }
    },
    SaveItem() {
      if (this.shwoTitle == true) {
        this.ClassPlanObj.checkList = this.checkList;
        axios
          .post(`${apiBaseUrl}/schedule/add`, this.ClassPlanObj, {
            headers: {
              authorization: sessio添加排课nStorage.getItem("tokenInfo"),
            },
          }) // 请替换为你的API URL
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg);
              this.getListData();
            } else {
              this.$message.error(res.data.msg);
            }
            this.classPlanDia = false;
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        delete this.ClassPlanObj.checkList;
        axios
          .put(`${apiBaseUrl}/schedule/updateschedule`, this.ClassPlanObj, {
            headers: {
              authorization: sessionStorage.getItem("tokenInfo"),
            },
          }) // 请替换为你的API URL
          .then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg);
              this.getListData();
            } else {
              this.$message.error(res.data.msg);
            }
            this.classPlanDia = false;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    addClassPlan() {
      this.classPlanDia = true;
      this.shwoTitle = true;
      (this.ClassPlanObj.isFirst = ""),
        (this.ClassPlanObj.educationType = 2),
        (this.ClassPlanObj.relativeTime = "4"),
        (this.ClassPlanObj.num = 0),
        (this.ClassPlanObj.courseEndTime = ""),
        (this.ClassPlanObj.courseTimeOn = ""),
        (this.ClassPlanObj.categoryId = ""),
        (this.ClassPlanObj.teacherId = ""),
        (this.ClassPlanObj.courseDate = "");
      this.checkList = [];
    },
    changeSelection(row) {
      this.batchDelArr = row.map((item) => item.scheduleId);
    },
    handleSizeChange(val) {

    },
    handleSizeChanges(val) {

    },
    handleSizeChange1(val) {

    },

    handleSizeChangess(val) {
      this.pageSizes = val;
      this.handleSearchBtn1();
    },

    handleCurrentChangess(val) {
      this.pageNums = val;
      this.handleSearchBtn1();
    },

    getListData() {
      let data = {
        pageNum: this.paging.pageNum,
        pageSize: this.paging.pageSize,
        studentId: this.id,
        categoryId: this.serachObj.categoryId,
        startDate: this.serachObj.createTimes[0]
          ? this.serachObj.createTimes[0]
          : "",
        endDate: this.serachObj.createTimes[1]
          ? this.serachObj.createTimes[1]
          : "",
        classEnding: this.serachObj.classEnding,
        educationType: this.serachObj.educationType,
        teacherId: this.serachObj.teacherId,
      };
      axios
        .post(`${apiBaseUrl}/schedule/selectscheduleByStudent`, data, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        }) // 请替换为你的API URL
        .then((res) => {
          this.tableData = res.data.data.records;
          this.totalAll = res.data.data.total;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getExamList() {
      let data = {
        examStage: this.resultList.examStage,
        startTime: this.resultList.timers[0] || "",
        endTime: this.resultList.timers[1] || "",
        studentId: this.id,
        pageNo: this.resultList.pageNo,
        pageSize: this.resultList.pageSize,
      };
      axios
        .post(`${apiBaseUrl}/exam/examList`, data, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.secondListData = res.data.data.records;
            this.resultList.total = res.data.data.total;
            this.resultList.pageSize = res.data.data.size;
            this.resultList.pageNo = res.data.data.pages;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    handleClearBtnRearch() {
      this.resultList = {
        examStage: "",
        timers: [],
        pageNo: 1,
        pageSize: 10,
      };
      this.getExamList();
    },
    handleSearchBtnRearch() {
      this.getExamList();
    },

    handleCurrentChange1(v) {
      this.serachObj.nums = v;
      this.serachObj.pageNo = v;
      this.getStudentDetails();
    },
    handleCurrentChange(v) {
      this.resultList.pages = v;
      this.getListData();
    },
    handleCurrentChanges(v) {
      this.paging.pageNo = v;
      this.getExamList();
    },
    startTimeSelect(val, row) {
      if (val == "start") {
        this.ClassPlanObj.courseTimeOn = row;
      } else {
        this.ClassPlanObj.courseEndTime = row;
      }
    },
    clean(val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = "";
      } else {
        this.diagnosisOff.endTimeHour = "";
      }
    },
    clic(row) {
      this.courseList[row.$index].flog = !this.courseList[row.$index].flog;
      this.$set(this.courseList, row.$index, this.courseList[row.$index]);
      this.keys = Math.random();
    },
    clickitem(val) {
      // val != this.contractId ? val == this.contractId ? this.contractId = '' : this.contractId = val : this.contractId = ""
      // this.contractId = val
      if (this.FormData.contractId == val) {
        this.FormData.contractId = "";
      } else {
        this.FormData.contractId = val;
      }
    },

    //获取所有方案
    getAllPlan() {

      // axios.post(`${apiBaseUrl}/contract/getList`, this.requestParameters, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
      //     this.planArr = res.data.data.records;
      //   }).catch((error) => {
      //     console.error(error);
      // })

      axios.get(`${apiBaseUrl}/sign_contract/findByList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
          if(res.data.code === 200){
              if(res.data.data && res.data.data.length > 0){
                this.planArr = res.data.data
              }else{
                this.planArr = []
              }
          }else{
            this.planArr = []
            this.$message.error(res.data.message)
          }
          }).catch(error => {
            this.$message.error(error)
      })


      axios.post(`${apiBaseUrl}/contract/getList`, this.requestParameters, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          this.planArr1 = res.data.data.records;
        }).catch((error) => {
          console.error(error);
      })

    },
    goBack() {
      // this.$EventBus.$emit('peagNum', this.peagNum)
      window.sessionStorage.setItem('pages',this.peagNum)
      history.go(-1);
    },
    //获取年级
    getGrade() {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error",
            });
          }
        })
        .catch((error) => {

        });
    },
    //获取老师列表
    getTeacherList() {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        }) // 请替换为你的API URL
        .then((response) => {
          this.teacherLists = response.data.data; // 将获取的数据赋值给teachers数组
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //查询课程列表
    fetchCourses() {
      axios
        .get(`${apiBaseUrl}/schedule/categorylist`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((response) => {
          this.courses = response.data.data;
          this.className = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    refresh() {
      this.getProductList();
    },
    //回显学生信息
    allStudent() {
      axios
        .get(`${apiBaseUrl}/student/${this.id}`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          //
          // this.studentData.realname = res.data.data.realname;
          // this.studentData.sex = res.data.data.sex;

          // this.studentData.telephone = res.data.data.telephone;
          // this.studentData.address = res.data.data.address;
          // this.studentData.progressTeacherIds =
          //   res.data.data.progressTeacherIds;
          // this.studentData.progressTeacherName =
          //   res.data.data.progressTeacherName;

          // this.studentData.teacherId = res.data.data.teacherId

          // this.studentDatas = res.data.data
          this.studentName = res.data.data.realname;
          this.studentData = res.data.data;

          this.contractId = res.data.data.contractId;
          // this.studentDatas.sexStr = res.data.data.sex + "";
          // this.studentDatas.grades = JSON.parse(res.data.data.grade)

          this.studentData.sexStr = res.data.data.sexStr + "";
          // this.studentData.sex = res.data.data.sex + "";
        })
        .catch((err) => {

        });
    },
    //获取跟进老师
    getTeacher() {
      axios
        .get(`${apiBaseUrl}/teacher/teacherList`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((response) => {
          this.salesName = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //点击修改信息
    cancelStudent() {
      this.showDialog = true;
      this.showDing = false;
      axios
        .get(`${apiBaseUrl}/student/${this.id}`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          this.studentDatas = res.data.data;
          this.studentDatas.sex = res.data.data.sex + "";
          this.studentDatas.grades = JSON.parse(res.data.data.grade);
        })
        .catch((err) => {

        });
    },
    //修改学生保存信息
    submitForm() {
      axios
        .post(`${apiBaseUrl}/student/modify/${this.id}`, this.studentDatas, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          this.$message({ message: "更新成功", type: "success" });
          //
          this.allStudent();
          this.showDialog = false;
        })
        .catch((err) => {
          this.$message.error("更新失败");
        });
    },
    //选中事件
    handleSelectionChange(arr) {
      //
      const aa = [];
      for (let i = 0; i < arr.length; i++) {
        aa.push(arr[i].id);
        // 拿到选中行的产品id
        this.id2 = arr[i].id;
      }
      // this.prouctCheck = this.aa;
      this.prouctCheck = aa;
    },
    // 选中事件
    // handleSelectionChange(arr) {
    //   this.prouctCheck = arr;
    // },
    //查询产品列表
    getProductList() {
      axios
        .get(`${apiBaseUrl}/product/getList/${this.id}`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((response) => {
          this.productData = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //点击新加签约按钮
    newSigning() {
      this.$nextTick(() => {
        this.$refs.contractProducts.init();
      });
    },
    addigning() {
      // this.handlefindStudentContract()
      this.showDing = true;
      this.isAdd = false;
      this.FormData.contractId = this.contractId;

      axios.get(`${apiBaseUrl}/student/findStudentContract/${this.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },  })  .then((res) => {

          if(res.data.code === 200){
             if( res.data.data &&  res.data.data.length > 0){

                 this.isCyop = res.data.data
                 res.data.data.map((itme)=>{
                    if(itme.contractType === 2){
                      let checkList1 = []
                      checkList1.push(itme.contractId)
                      this.checkList1 = checkList1
                    }
                    if(itme.contractType === 1){
                      let checkList2 = []
                      checkList2.push(itme.contractId)
                      this.checkList2 = checkList2
                    }
                 })


                 this.planArr.forEach((i)=>{
                    res.data.data.map((ii)=>{
                       if(ii.contractType === 2){
                          if(i.id === ii.contractId){
                            i.periodStartTime = ii.periodStartTime
                            i.periodEndTime = ii.periodEndTime
                          }
                       }
                    })
                 })

                 this.planArr1.forEach((i)=>{
                    res.data.data.map((ii)=>{
                       if(ii.contractType === 1){
                          if(i.id === ii.contractId){
                            i.periodStartTime = ii.periodStartTime
                            i.periodEndTime = ii.periodEndTime
                          }
                       }
                    })
                 })

             }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch((error) => {
          this.$message.error(error)
      })


    },

    addigning1() {
      this.handlefindStudentContract()
      this.showDing = true;
      this.isAdd = true;
      this.FormData.contractId = this.contractId;

      axios.get(`${apiBaseUrl}/student/findStudentContract/${this.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },  })  .then((res) => {
          if(res.data.code === 200){
             if( res.data.data &&  res.data.data.length > 0){
                 res.data.data.map((itme)=>{
                    if(itme.contractType === 2){
                      let checkList1 = []
                      checkList1.push(itme.id)
                      this.checkList1 = checkList1
                    }
                    if(itme.contractType === 1){
                      let checkList2 = []
                      checkList2.push(itme.id)
                      this.checkList2 = checkList2
                    }
                 })
             }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch((error) => {
          this.$message.error(error)
      })

    },


    handlefindStudentContract(){
      axios.get(`${apiBaseUrl}/sign_contract/findByList`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },  })  .then((res) => {
          if(res.data.code === 200){
            // console.log(res.data,'res.datares.datares.datares.data')
          }else{
            this.$message.error(res.data.message);
          }
        }) .catch((error) => {
          this.$message.error(error)
      })
    },

    //修改签约按钮
    editSigning() {
      if (!this.prouctCheck || this.prouctCheck.length === 0) {
        this.$message.error("请先选择要修改的产品");
        return;
      }

      if (!this.prouctCheck || this.prouctCheck.length !== 1) {
        this.$message.error("请选择且只能选择一个产品");
        return;
      }
      this.showVisibleDialog = true;
      axios
        .get(`${apiBaseUrl}/product/getById/${this.id2}`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          // this.FormData.categoryId = res.data.data.categoryId;
          // this.FormData.id = res.data.data.id;
          // this.FormData.startTime = res.data.data.startTime;
          // this.FormData.classType = res.data.data.classType;
          // this.FormData.lessonNum = res.data.data.lessonNum;
          // this.FormData.lessonPrice = res.data.data.lessonPrice;
          // this.FormData.endTime = res.data.data.endTime;
          // this.FormData.categoryName = res.data.data.categoryName;
          this.FormData = res.data.data;

          this.Reasons = res.data.data.lossReasson;
          this.ReasonsTime = res.data.data.lossTime;
          this.radio = res.data.data.lossStatus;

          this.FormData.educationType = res.data.data.educationType ? res.data.data.educationType.split(",").map(Number)  : []

          // this.FormData.teacherList=res.data.data.teacherId+""
        })
        .catch((err) => {

        });
    },
    handleOkClick2(){


      let checkList1 = []
      this.planArr.map((item) => {
        this.checkList1.map((items) => {
            if (item.id === items) {
              let obj = {
                  id: this.isAdd ? item.id : '',
                  studentId: this.id,
                  contractId: item.id,
                  contractType: 2,
                  periodStartTime: item.periodStartTime,
                  periodEndTime: item.periodEndTime,
              }
              checkList1.push(obj)
            }
        })
      })

      let checkList2 = []
      this.planArr1.map((item) => {
        this.checkList2.map((items) => {
            if (item.id === items) {
                let obj = {
                    id: this.isAdd ? item.id : '',
                    studentId: this.id,
                    contractId: item.id,
                    contractType: 1,
                    periodStartTime: item.periodStartTime,
                    periodEndTime: item.periodEndTime,
                 }
                 checkList2.push(obj)
            }
        })
      })

      if(this.isCyop.length > 0){
        this.isCyop.map((item) => {
           if(item.contractType === 2){
              checkList1.forEach((itmes)=>{
                 if(itmes.contractId === item.contractId){
                     itmes.id = item.id
                 }
              })
           }
           if(item.contractType === 1){
              checkList2.forEach((itmes)=>{
                 if(itmes.contractId === item.contractId){
                     itmes.id = item.id
                 }
              })
           }
        })
      }

      let data = [...checkList1,...checkList2]


      axios.post(`${apiBaseUrl}/student/updateStudentContract/${this.id}`, data, { headers: {  authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
          if(res.data.code === 200){
            this.$message({ message: res.data.message, type: "success" });
            this.showVisibleDialog = false;
            this.showDing = false;
            this.getProductList();
            this.allStudent();
            this.getTeacher();
            this.getStudentDetails();
            this.getStudentStatistics();
            this.getProductList();
            this.fetchCourses();
            this.getTeacherList();
            this.getGrade();
            this.getAllPlan();
            this.getListData();
            this.getAllTeacher();
            this.checkList1 = []
            this.checkList2 = []
          }else{
            this.$message({ message: res.data.message, type: "error" });
          }
        }).catch((err) => {
          this.$message.error(err)
      })
    },

    //修改签约保存
    handleOkClick1() {
      const data = {
        contractId: this.FormData.contractId,
      };
      axios
        .put(`${apiBaseUrl}/student/modifyPlan/${this.id}`, data, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          this.$message({ message: "更新成功", type: "success" });
          this.showVisibleDialog = false;
          this.showDing = false;
          this.getProductList();
          this.allStudent();
          this.getTeacher();
          this.getStudentDetails();
          this.getStudentStatistics();
          this.getProductList();
          this.fetchCourses();
          this.getTeacherList();
          this.getGrade();
          this.getAllPlan();
          this.getListData();
          this.getAllTeacher();
        })
        .catch((err) => {
          this.$message.error("更新失败");
        });
    },
    handleOkClick() {
      const data = {
        categoryId: this.FormData.categoryId,
        id: this.id2,
        studentId: this.id,
        contractId: this.FormData.contractId,
        classType: this.FormData.classType,
        lessonNum: this.FormData.lessonNum,
        lessonPrice: this.FormData.lessonPrice,
        endTime: this.FormData.endTime,
        startTime: this.FormData.startTime,
        teacherId: this.FormData.teacherId,
        lossStatus: this.radio ? this.radio : 0,
        lossReasson: this.Reasons,
        lossTime: this.ReasonsTime || null,
        educationType : this.FormData.educationType.length > 0 ? this.FormData.educationType.join(',') : null
      };
      axios
        .post(`${apiBaseUrl}/product/update`, data, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          //
          this.$message({ message: "更新成功", type: "success" });
          this.showVisibleDialog = false;
          this.showDing = false;
          this.getProductList();
        })
        .catch((err) => {
          this.$message.error("更新失败");
        });
    },
    //删除签约
    // deleteSigning() {
    // this.prouctCheck 数组是否存在以及其长度是否为0，以确保至少选中一条数据。使用 map 方法从 this.prouctCheck 数组中提取选中数据的id，并将其存储在名为 ids 的数组中
    //   if (!this.prouctCheck || this.prouctCheck.length === 0) {
    //     this.$message.error("请先选择要删除的产品");
    //     return;
    //   }
    //   const ids = this.prouctCheck.map(item => item.id);
    //   axios
    //     .post(`${apiBaseUrl}/product/deleteByIds`, { ids })
    //     .then(response => {
    //
    //       if (response.data.code === 200) {
    //         this.$message.success("删除成功");
    //         // // 更新列表数据
    //         this.getProductList();
    //       } else {
    //         this.$message.error("删除失败");
    //       }
    //     })
    //     .catch(error => {
    //
    //     });
    // },
    deleteSigning() {
      if (this.productData.length <= 1) {
        this.$message.error("学生绑定的方案必须存在一条不可删除");
        return;
      }
      //
      if (!this.prouctCheck || this.prouctCheck.length === 0) {
        this.$message.error("请先选择要删除的产品");
        return;
      }
      axios
        .post(
          `${apiBaseUrl}/product/deleteByIds`,
          { ids: this.prouctCheck },
          {
            headers: {
              authorization: sessionStorage.getItem("tokenInfo"),
            },
          }
        )
        .then((response) => {

          if (response.data.code === 200) {
            this.$message.success("删除成功");
            // // 更新列表数据
            this.getProductList();
          } else {
            this.$message({ message: res.data.message, type: "error" });
          }
        })
        .catch((error) => {

        });
    },
    //获取课程明细
    getStudentDetails() {
      this.serachObj.startDate = this.serachObj.createTimes[0];
      this.serachObj.endDate = this.serachObj.createTimes[1];
      axios
        .post(`${apiBaseUrl}/student/student_details`, this.serachObj, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          // this.serachObj.nums = res.data.data.length
          this.courseList = res.data.data;
          this.courseList.forEach((item) => {
            item.flog = true;
          });
        })
        .catch((err) => {

        });
    },
    //获取课程统计
    getStudentStatistics() {
      axios
        .post(`${apiBaseUrl}/student/student_course_count/${this.id}`, {
          headers: {
            authorization: sessionStorage.getItem("tokenInfo"),
          },
        })
        .then((res) => {
          this.countList = res.data.data;

          // this.countList.push({
          //   courseName:res.data.data.courseName,
          //   alreadyTotalNum:res.data.data.alreadyTotalNum,
          //   courseTotalNum:res.data.data.courseTotalNum,
          //   expireTime:res.data.data.expireTime,
          //   remainTotalNum:res.data.data.remainTotalNum,
          //   children:res.data.data.teacherCourseInfos
          // })
          //
        })
        .catch((err) => {

        });
    },
    showEditDialog() {
      this.edit();
    },
    cancel() {
      this.showVisibleDialog = false;
    },
    cancel1() {
      this.showDing = false;
    },
  },

  // beforeDestroy(){
  //   this.$EventBus.$off('peagNum')
  // },

};
</script>

<style scoped>
.search {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.body {
  display: flex;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  align-items: center;
  justify-content: space-between;
}

.detail {
  float: left;
  margin-left: 10px;
}

.header {
  background-color: #fafafa;
  border: 1px solid #e1e1e1;
  margin-top: 10px;
}

.headers {
  background-color: #fafafa;
  border: 1px solid #e1e1e1;
  margin-top: 10px;
}

.headerss {
  background-color: #fafafa;
  border: 1px solid #e1e1e1;
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  font-weight: 500;
}

.footer {
  /* background-color: #fff; */
  margin-top: 10px;
  /* height: 300px; */
}

.ft {
  background-color: #fff;
  /* height: 500px; */
}

.stu {
  margin-left: 10px;
  margin-right: 10px;
}

.deep {
  background-color: #fff;
  margin-top: 10px;
  height: 300px;
}

.course {
  margin-left: 10px;
  margin-right: 10px;
}

.name-link {
  text-decoration: none;
  /* 这将移除下划线 */
}

.sub {
  border: 1px solid #e1e1e1;
  height: 55px;
}

.realname {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

.card {
  height: 40px;
}

.dd {
  float: left;
  border-radius: 50px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  background-color: #1c86ee;
  margin-left: 15px;
  margin-top: -25px;
  margin-right: 20px;
}

.bbb {
  width: 70%;
}

.mes {
  display: flex;
  margin-left: 20px;
  white-space: nowrap;
}

.table {
  margin-left: 10px;
  margin-right: 10px;
}

.sign {
  background-color: #fff;
  margin-top: 10px;
  /* height: 700px; */
}

.line {
  margin-top: -16px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #oo >>> .el-dialog {
    width: 70% !important;
  }

  .pop {
    margin-left: -15% !important;
  }

  #ff >>> .el-dialog {
    width: 70% !important;
  }
}

.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}

.remark::before {
  content: "*";
  color: red;
  font-size: 16px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/StudentDetail（copy）.vue